module.exports = __webpack_public_path__ + "static/looking-for-the-wayout_acrylic-on-cardboard-85x105in-2016-4487f1691d0d7b273bfe26dc68d425e0.jpg";